import BaseService from './BaseService';

export default class extends BaseService {
  static index(options = {}) {
    const url = super.url('no_sprays');

    if (options.page) {
      url.searchParams.append('no_sprays', options.page);
    }

    return super
      .get(url)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error.response.data);
      });
  }

  static getNoSprays(pageNo = 1, resultList = [], extraParams = '') {
    let url = super.url("no_sprays") + `?page[number]=${pageNo}&page[size]=${100}&${extraParams}`
    return super.get(url).then(response => {
      if (response.data.noSprays.length > 0) {
        resultList = resultList.concat(response.data.noSprays)
        return this.getNoSprays(pageNo+1, resultList, extraParams)
      } else {
        return Promise.resolve(resultList)
      }
    }).catch(error => {
      console.log(error)
      return Promise.reject(error)
    })
  }

  static getNoSpraysInArea({sw, ne}) {
    const extraParams = `bbox[sw]=${sw.lat},${sw.lng}&bbox[ne]=${ne.lat},${ne.lng}`;
    return this.getNoSprays(1, [], extraParams);
  }

  static getNoSpraysByName(query) {
    const url = `${super.url('no_sprays')}?q=${query}&paginate=false`;
    return super.get(url);
  }
}
